export default {
  authGroups: {
    systemAdmin: {
      label: 'Системийн админ',
      label_plural: 'Системийн админууд',
      description: 'OF Arena системийн админууд',
    },
    surveyManager: {
      label: 'Судалгааны менежер',
      label_plural: 'Судалгааны менежерүүд',
      description: 'OF Arena судалгааны менежерүүд',
    },
    surveyAdmin: {
      label: 'Судалгааны админ',
      label_plural: 'Судалгааны админууд',
      description: 'Бүрэн эрх',
    },
    surveyEditor: {
      label: 'Судалгааны редактор',
      label_plural: 'Судалгааны редакторууд',
      description: 'Судалгаа, бүртгэл засах, хэрэглэгч урих боломжтой',
    },
    dataEditor: {
      label: 'Өгөгдөл засагч',
      label_plural: 'Өгөгдөл засагчид',
      description: 'Өгөгдөл оруулах алхамд бүртгэл засах боломжтой',
    },
    dataCleanser: {
      label: 'Өгөгдөл цэвэрлэгч',
      label_plural: 'Өгөгдөл цэвэрлэгчид',
      description: 'Өгөгдөл цэвэрлэх алхамд бүртгэл засах боломжтой',
    },
    dataAnalyst: {
      label: 'Өгөгдөл аналист',
      label_plural: 'Өгөгдөл аналистууд',
      description: 'Өгөгдөл шинжилгээний алхамд бүртгэл засах боломжтой',
    },
    surveyGuest: {
      label: 'Судалгааны зочин',
      label_plural: 'Судалгааны зочид',
      description: 'Бичлэгийг үзэх боломжтой',
    },
  },
}
